export default __webpack_public_path__ + "static/media/review.578c41f0.png";